import { render, staticRenderFns } from "./puppy-purchase.vue?vue&type=template&id=68dcc81e&scoped=true&lang=pug"
import script from "./puppy-purchase.js?vue&type=script&lang=js&external"
export * from "./puppy-purchase.js?vue&type=script&lang=js&external"
import style0 from "./puppy-purchase.vue?vue&type=style&index=0&id=68dcc81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcc81e",
  null
  
)

export default component.exports